import React from "react";
import { motion } from "framer-motion";
import {
    FaUsers, FaLeaf, FaMoneyBillWave,
    FaWarehouse, FaFileInvoice, FaCog, FaLock, FaSeedling,
} from "react-icons/fa";

const Dashboard = () => {
    const modules = [
        { icon: FaUsers,         label: "Members",      desc: "Farmer member records & onboarding" },
        { icon: FaMoneyBillWave, label: "Transactions",  desc: "Financial logs, payments & dues" },
        { icon: FaLeaf,          label: "Commodities",   desc: "Crop stock & produce tracking" },
        { icon: FaFileInvoice,   label: "Invoices",      desc: "Billing, GST & receipts" },
        { icon: FaWarehouse,     label: "Warehouse",     desc: "Inventory & storage management" },
        { icon: FaCog,           label: "Settings",      desc: "FPO portal configurations" },
    ];

    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center py-10 px-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.95, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="max-w-3xl w-full bg-white rounded-3xl shadow-xl border border-gray-100 p-8 sm:p-12 text-center relative overflow-hidden"
            >
                {/* Decorative background gradients */}
                <div className="absolute -top-20 -right-20 w-56 h-56 bg-primary/10 rounded-full blur-2xl pointer-events-none" />
                <div className="absolute -bottom-20 -left-20 w-56 h-56 bg-emerald-200/30 rounded-full blur-2xl pointer-events-none" />

                {/* Top Badge & Icon */}
                <div className="flex justify-center mb-5">
                    <motion.div
                        animate={{ y: [0, -6, 0] }}
                        transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
                        className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-emerald-600 flex items-center justify-center shadow-lg shadow-primary/30"
                    >
                        <FaSeedling className="text-white text-3xl" />
                    </motion.div>
                </div>

                <span className="inline-block bg-primary/10 text-primary border border-primary/20 text-xs font-semibold px-3 py-1 rounded-full mb-3 uppercase tracking-wider">
                    FPO Dashboard
                </span>

                <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1a4a4a] mb-3">
                    Coming Soon
                </h1>

                <p className="text-gray-500 text-sm sm:text-base max-w-lg mx-auto mb-10 leading-relaxed">
                    We are crafting powerful analytics, member management, commodity tracking, and transaction tools for your FPO. Stay tuned!
                </p>

                {/* Modules Grid */}
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-left">
                    {modules.map((item, i) => (
                        <motion.div
                            key={item.label}
                            initial={{ opacity: 0, y: 15 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: i * 0.08 + 0.2 }}
                            className="bg-gray-50/80 hover:bg-gray-50 rounded-2xl p-4 border border-gray-100 flex flex-col justify-between group relative overflow-hidden"
                        >
                            <div className="flex items-center justify-between mb-3">
                                <div className="w-9 h-9 rounded-xl bg-white shadow-sm border border-gray-100 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                                    <item.icon className="text-base" />
                                </div>
                                <span className="flex items-center gap-1 text-[10px] bg-amber-50 text-amber-600 border border-amber-200 px-2 py-0.5 rounded-full font-semibold">
                                    <FaLock className="text-[8px]" /> Soon
                                </span>
                            </div>
                            <div>
                                <h4 className="text-xs font-bold text-gray-800 mb-0.5">{item.label}</h4>
                                <p className="text-[11px] text-gray-400 leading-tight">{item.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </motion.div>
        </div>
    );
};

export default Dashboard;
